module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('symbol', {
    attrs: {
      "id": "icon-cart",
      "viewBox": "0 0 38 32"
    }
  }, [_c('title')]), _vm._v(" "), _c('div', {
    staticClass: "el-header"
  }, [_c('div', {
    staticStyle: {
      "min-width": "1200px !important",
      "width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('div', [_c('img', {
    staticClass: "header-logo-css",
    attrs: {
      "src": require("../../static/images/logo.png")
    },
    on: {
      "click": _vm.openGoodsList
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right-container",
    staticStyle: {
      "display": "flex",
      "float": "right",
      "margin-top": "-55px"
    }
  }, [_c('div', {
    staticClass: "navbar-menu-container"
  }, [_c('span'), _vm._v(" "), _c('div', {
    staticClass: "header-cart-div",
    on: {
      "click": _vm.toCart
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/购物车.png")
    }
  }), _vm._v(" "), (_vm.cartCount > 0) ? _c('span', {
    staticClass: "navbar-cart-count",
    staticStyle: {
      "top": "-5px",
      "right": "-10px"
    }
  }, [_vm._v(_vm._s(_vm.cartCount))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "header-Mycart-css",
    on: {
      "click": _vm.toCart
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "header-cartLine-css"
  }), _vm._v(" "), _c('span', {
    staticClass: "header-Myoder-css",
    on: {
      "click": _vm.myOrder
    }
  }, [_vm._v("我的订单")]), _vm._v(" "), _c('span', {
    staticClass: "header-orderLine-css"
  }), _vm._v(" "), _c('el-popover', {
    ref: "popover1",
    attrs: {
      "trigger": "hover",
      "placement": "bottom",
      "disabled": _vm.isPopover
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', [_c('p', {
    staticClass: "header-name"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('p', {
    staticClass: "header-userName"
  }, [_vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('span', {
    staticClass: "header-userName-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "logout",
    on: {
      "mouseover": function($event) {
        return _vm.changeIndex(1)
      },
      "mouseout": function($event) {
        return _vm.changeIndexBack(1)
      }
    }
  }, [_c('img', {
    staticClass: "header-logout-img",
    attrs: {
      "src": _vm.indexCenter1
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "header-logout-font",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出登录")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('img', {
    staticClass: "header-photoImg-css",
    attrs: {
      "slot": "reference",
      "id": "avatarId",
      "src": _vm.logoUrl == '/mallApi' || _vm.logoUrl == '/mallApidata:image/jpeg;base64,' ? '../../static/images/28X28.png' : _vm.logoUrl
    },
    slot: "reference"
  }), _vm._v(" "), _c('span', {
    staticClass: "header-lan-name",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.userName))])])])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20cd5ea9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 321
// module chunks = 2